export default {
  o_loan_popup_msg: val => `是否確認領取${val}的貸款金額？ `,
}